import {IFavourite} from "@pg-mono/favourites";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, priceFormat, priceM2Format, roomsFormat} from "@pg-mono/string-utils";

export interface IFavouriteTopbarOffer {
    rp_id: number;
    name?: string | null;
    slug?: string;
    vendor?: {
        name?: string;
        slug?: string;
    };
    main_image?: {
        m_img_224x147?: string;
        m_img_500?: string;
    } | null;
    images?: {
        thumbnails?: {
            g_img_500?: string;
        };
    }[];
}

export interface IFavouriteTopbarSource extends IFavourite {
    name?: string | null;
    location?: string | null;
    price?: number | string | null;
    price_m2?: number | string | null;
    rooms?: number | null;
    area?: number | string | null;
    offer: IFavouriteTopbarOffer | null;
    property: {
        id?: number;
        rp_id: number;
        url?: string;
        rooms?: number | null;
        area?: number | string | null;
        price?: number | string | null;
        price_m2?: number | string | null;
        images?: {
            thumbnails?: {
                g_img_500?: string;
            };
        }[];
        offer?: IFavouriteTopbarOffer | null;
    } | null;
}

export interface IFavouritesTopbarCard {
    propertyId: number;
    offerId: number | null;
    href: string | null;
    name: string;
    imageUrl: string | null;
    priceLabel: string | null;
    priceM2Label: string | null;
    metaLabel: string | null;
}

export const FAVOURITES_TOPBAR_PREVIEW_LIMIT = 3;

export const mapFavouriteToTopbarCard = (favourite: IFavouriteTopbarSource): IFavouritesTopbarCard | null => {
    const propertyId = favourite.property?.rp_id;
    const offer = favourite.property?.offer ?? favourite.offer;
    const vendorSlug = offer?.vendor?.slug;
    const offerSlug = offer?.slug;
    const offerId = offer?.rp_id ?? favourite.offer?.rp_id;

    if (propertyId == null) {
        return null;
    }

    const price = parseFavouriteNumber(favourite.property?.price ?? favourite.price);
    const priceM2 = parseFavouriteNumber(favourite.property?.price_m2 ?? favourite.price_m2);
    const rooms = parseFavouriteNumber(favourite.property?.rooms ?? favourite.rooms);
    const area = parseFavouriteNumber(favourite.property?.area ?? favourite.area);
    const metaParts = [rooms != null ? roomsFormat(rooms) : null, area != null ? areaFormat(area) : null].filter(Boolean);

    return {
        propertyId,
        offerId: offerId ?? null,
        href: getFavouriteHref(propertyId, vendorSlug, offerSlug, offerId, favourite.property?.url),
        name: favourite.name || offer?.name || favourite.location || "Oferta",
        imageUrl: getFavouriteImageUrl(favourite, offer),
        priceLabel: price != null ? (priceFormat(price) ?? null) : null,
        priceM2Label: priceM2 != null ? (priceM2Format(priceM2) ?? null) : null,
        metaLabel: metaParts.length > 0 ? metaParts.join(" · ") : null
    };
};

export const getFavouritesTopbarCards = (favourites: IFavouriteTopbarSource[]): IFavouritesTopbarCard[] => {
    return favourites.map(mapFavouriteToTopbarCard).filter((card): card is IFavouritesTopbarCard => card != null);
};

export const getFavouritesTopbarPreviewCards = (favourites: IFavouriteTopbarSource[]): IFavouritesTopbarCard[] => {
    return getFavouritesTopbarCards(favourites).slice(0, FAVOURITES_TOPBAR_PREVIEW_LIMIT);
};

const getFavouriteHref = (
    propertyId: number,
    vendorSlug: string | undefined,
    offerSlug: string | undefined,
    offerId: number | undefined,
    propertyUrl: string | undefined
): string | null => {
    if (vendorSlug && offerSlug && offerId != null) {
        return rpAppLink.property.detail.base({
            vendorSlug,
            offerSlug,
            offerId,
            propertyId
        });
    }

    return propertyUrl || null;
};

const getFavouriteImageUrl = (favourite: IFavouriteTopbarSource, offer: IFavouriteTopbarOffer | null): string | null => {
    return (
        offer?.main_image?.m_img_224x147 ||
        offer?.main_image?.m_img_500 ||
        offer?.images?.[0]?.thumbnails?.g_img_500 ||
        favourite.property?.images?.[0]?.thumbnails?.g_img_500 ||
        null
    );
};

const parseFavouriteNumber = (value: number | string | null | undefined): number | null => {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== "string" || value.trim() === "") {
        return null;
    }

    const parsed = Number(value.replace(/\s/g, "").replace(",", "."));

    return Number.isFinite(parsed) ? parsed : null;
};
import {IFavourite} from "@pg-mono/favourites";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, priceFormat, priceM2Format, roomsFormat} from "@pg-mono/string-utils";

export interface IFavouriteTopbarOffer {
    rp_id: number;
    name?: string | null;
    slug?: string;
    vendor?: {
        name?: string;
        slug?: string;
    };
    main_image?: {
        m_img_224x147?: string;
        m_img_500?: string;
    } | null;
    images?: {
        thumbnails?: {
            g_img_500?: string;
        };
    }[];
}

export interface IFavouriteTopbarSource extends IFavourite {
    name?: string | null;
    location?: string | null;
    price?: number | string | null;
    price_m2?: number | string | null;
    rooms?: number | null;
    area?: number | string | null;
    offer: IFavouriteTopbarOffer | null;
    property: {
        id?: number;
        rp_id: number;
        url?: string;
        rooms?: number | null;
        area?: number | string | null;
        price?: number | string | null;
        price_m2?: number | string | null;
        images?: {
            thumbnails?: {
                g_img_500?: string;
            };
        }[];
        offer?: IFavouriteTopbarOffer | null;
    } | null;
}

export interface IFavouritesTopbarCard {
    propertyId: number;
    offerId: number | null;
    href: string | null;
    name: string;
    imageUrl: string | null;
    priceLabel: string | null;
    priceM2Label: string | null;
    metaLabel: string | null;
}

export const FAVOURITES_TOPBAR_PREVIEW_LIMIT = 3;

export const mapFavouriteToTopbarCard = (favourite: IFavouriteTopbarSource): IFavouritesTopbarCard | null => {
    const propertyId = favourite.property?.rp_id;
    const offer = favourite.property?.offer ?? favourite.offer;
    const vendorSlug = offer?.vendor?.slug;
    const offerSlug = offer?.slug;
    const offerId = offer?.rp_id ?? favourite.offer?.rp_id;

    if (propertyId == null) {
        return null;
    }

    const price = parseFavouriteNumber(favourite.property?.price ?? favourite.price);
    const priceM2 = parseFavouriteNumber(favourite.property?.price_m2 ?? favourite.price_m2);
    const rooms = parseFavouriteNumber(favourite.property?.rooms ?? favourite.rooms);
    const area = parseFavouriteNumber(favourite.property?.area ?? favourite.area);
    const metaParts = [rooms != null ? roomsFormat(rooms) : null, area != null ? areaFormat(area) : null].filter(Boolean);

    return {
        propertyId,
        offerId: offerId ?? null,
        href: getFavouriteHref(propertyId, vendorSlug, offerSlug, offerId, favourite.property?.url),
        name: favourite.name || offer?.name || favourite.location || "Oferta",
        imageUrl: getFavouriteImageUrl(favourite, offer),
        priceLabel: price != null ? (priceFormat(price) ?? null) : null,
        priceM2Label: priceM2 != null ? (priceM2Format(priceM2) ?? null) : null,
        metaLabel: metaParts.length > 0 ? metaParts.join(" · ") : null
    };
};

export const getFavouritesTopbarCards = (favourites: IFavouriteTopbarSource[]): IFavouritesTopbarCard[] => {
    return favourites.map(mapFavouriteToTopbarCard).filter((card): card is IFavouritesTopbarCard => card != null);
};

export const getFavouritesTopbarPreviewCards = (favourites: IFavouriteTopbarSource[]): IFavouritesTopbarCard[] => {
    return getFavouritesTopbarCards(favourites).slice(0, FAVOURITES_TOPBAR_PREVIEW_LIMIT);
};

const getFavouriteHref = (
    propertyId: number,
    vendorSlug: string | undefined,
    offerSlug: string | undefined,
    offerId: number | undefined,
    propertyUrl: string | undefined
): string | null => {
    if (vendorSlug && offerSlug && offerId != null) {
        return rpAppLink.property.detail.base({
            vendorSlug,
            offerSlug,
            offerId,
            propertyId
        });
    }

    return propertyUrl || null;
};

const getFavouriteImageUrl = (favourite: IFavouriteTopbarSource, offer: IFavouriteTopbarOffer | null): string | null => {
    return (
        offer?.main_image?.m_img_224x147 ||
        offer?.main_image?.m_img_500 ||
        offer?.images?.[0]?.thumbnails?.g_img_500 ||
        favourite.property?.images?.[0]?.thumbnails?.g_img_500 ||
        null
    );
};

const parseFavouriteNumber = (value: number | string | null | undefined): number | null => {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== "string" || value.trim() === "") {
        return null;
    }

    const parsed = Number(value.replace(/\s/g, "").replace(",", "."));

    return Number.isFinite(parsed) ? parsed : null;
};
